// TODO: FE-2912
export function FormSubmissionCategory() {
  return 'form-submission';
}
